import { initialAction, initialState } from './initial';

type Reducer = (
  state: typeof initialState,
  action: typeof initialAction,
) => typeof initialState;

const reducer: Reducer = (state, action) => {
  const { type, payload } = action ?? {};

  switch (type) {
    case 'UPDATE_DISCOUNT_CODE_TYPE':
    case 'UPDATE_DISCOUNT_CODE_AMOUNT':
    case 'UPDATE_DISCOUNT_CODE_DURATION': {
      return {
        ...state,
        ...payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer };
